import ManageClientTags from './ManageClientTags';

export default ManageClientTags;
